import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import * as React from 'react';
import { Provider } from 'react-redux';

import { TReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../ApplicationContext';
import { PageContainer } from '../PageContainer';

export interface IApplicationProps {
  reduxStore: TReduxStore;
  context: IApplicationContext;
}

export const Application: React.FC<IApplicationProps> = ({ context, reduxStore }) => {
  return (
    <ErrorLogComponent logger={context.logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={context.custom.initialDeviceType}>
          <MicrofrontendProvider registry={context.microfrontendsRegistry}>
            <Provider store={reduxStore}>
              <PageContainer />
            </Provider>
          </MicrofrontendProvider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
